/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, HostBinding, HostListener, AfterViewInit } from '@angular/core';
import { ConfigService } from './shared/services/config/config.service';
import { PreloaderService } from './shared/services/preloader/preloader.service';
import { SpinnerService } from './shared/services/spinner/spinner.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  // App Left Sidebar Menu Open/Close Desktop
  @HostBinding('class.app_sidebar-menu-collapsed')
  get isApp_SidebarLeftCollapsed() {
    return this.config.appLayout.isApp_SidebarLeftCollapsed;
  }
  // Left Menu Sidebar Open/Close Tablet & Mobile
  @HostBinding('class.app_sidebar-left-open')
  get isApp_MobileSidebarLeftOpen() {
    return this.config.appLayout.isApp_MobileSidebarLeftOpen;
  }
  // App Right Sidebar Open/Close
  @HostBinding('class.sidebar-overlay-open')
  get isApp_SidebarRightOpen() {
    return this.config.appLayout.isApp_SidebarRightOpen;
  }

  constructor(
    public config: ConfigService,
    private _spinner: SpinnerService
  ) {
    ConfigService.setApiHost(environment.apiUrl);
  }

  // Check if menu should reset on resize
  @HostListener('window:resize')
  public onWindowResize(): void {
    if (this._shouldMenuReset()) {
      this.config.appLayout.isApp_SidebarLeftCollapsed = false;
    }
  }

  private _shouldMenuReset(): boolean {
    return window.innerWidth <= this.config.breakpoint.desktopLG;
  }

  public ngAfterViewInit(): void {
    PreloaderService.load().then(values => {
      this._spinner.hide();
    });
  }
}
